import React, { useState, useEffect } from "react";
import { useClerk, useAuth } from "@clerk/clerk-react";
import { Row, Col, Layout, Button, Image, Drawer } from "antd";
import "../components/header.css";
import logo from "../assets/images/logo.svg";
import vastu_logo from "../assets/images/vastu_logo.jpeg";
import { Typography, Menu } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import { Link, useHistory, useLocation } from "react-router-dom";

const HomeHeader = () => {
  const history = useHistory();
  const { isMobile, isTablet, isDesktop } = useBreakpoints();
  const clerk = useClerk();
  const { isSignedIn } = useAuth();
  const { isSuperLarge } = useBreakpoints();

  const [open, setOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const location = useLocation();

  // const handleMenuClick = (onClick) => {
  //   if (onClick) onClick();
  //   setOpen(false);
  // };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Set initial value
    setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const scrollToSection = (section) => {
    setOpen(false);
    if (section === "post") {
      history.push("/post");
      return;
    }
    if (location.pathname === "/") {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      history.push("/");
      setTimeout(() => {
        const sectionId = section?.replace("/", "");
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  const menuItems = [
    { key: "5", label: "Home", path: "/", },
    { key: "1", label: "About Us", section: "aboutus" },
    {
      key: "2",
      label: "Property Service",
      section: "service",
    },
    { key: "4", label: "Find on Map", path: "/map", },
    {
      key: "3",
      label: (
        <div className="sideBySideButtons">
          <Button
            className="postProperty"
            onClick={(e) => {
              e.stopPropagation();
              history.push("/post");
            }}
          >
            Post Property
          </Button>

          {location.pathname === "/admin" && (
            <Button
              className="signIn"
              onClick={(e) => {
                e.stopPropagation();
                clerk.redirectToSignIn({ redirectUrl: window.location.origin + '/app' });
              }}
            >
              Sign in
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Row justify="center" style={{ padding: "15px 0px" }}>
      <Col
        xs={22}
        sm={22}
        md={22}
        lg={18}
        xl={20}
        xxl={16}
        style={{ maxWidth: isSuperLarge ? "50%" : "" }}
      >
        <Row align='middle' justify='space-between' style={{ width: '100%', flexWrap: 'nowrap' }}>
          <Col flex="1" style={{ minWidth: 0 }}>
            <Row gutter={[8, 0]} align="middle" style={{ flexWrap: 'nowrap' }}>
              <Col style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                <img
                  src={vastu_logo}
                  alt="Logo"
                  style={{ height: isMobile ? "70px" : "100px", cursor: "pointer" }}
                  onClick={() => history.push("/")}
                />
              </Col>
              <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", minWidth: 0 }}>
                <Typography
                  className="logoHeading"
                  style={{
                    fontSize: isMobile ? "16px" : "24px",
                    lineHeight: isMobile ? "20px" : "28px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: isMobile ? "normal" : "nowrap"
                  }}
                >
                  Shree Vastu Management and Developers
                </Typography>
                <Typography
                  className="logoText"
                  style={{
                    fontSize: isMobile ? "10px" : "14px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}
                >
                  RERA: AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA01298/271025R1
                </Typography>
              </Col>
            </Row>
          </Col>

          {isMobile ? (
            <Col style={{ marginLeft: '10px', flexShrink: 0 }}>
              <Button icon={<MenuOutlined />} onClick={() => setOpen(true)} />
            </Col>
          ) : (
            (isDesktop || isTablet) && (
              <Col style={{ position: 'absolute', right: 0 }}>
                <Row gutter={20} align="middle" style={{ height: '95px', display: 'flex', alignContent: 'end' }}>
                  {menuItems.map(({ key, label, section, path }) => (
                    <Col key={key} onClick={() => {
                      if (section) {
                        scrollToSection(section);
                      } else if (path) {
                        history.push(path);
                      }
                    }}>
                      {typeof label === "string" ? (
                        <Typography className="navbarText">{label}</Typography>
                      ) : (
                        label
                      )}
                    </Col>
                  ))}
                </Row>
              </Col>
            )
          )}
        </Row>

        <Drawer
          title="Menu"
          placement="right"
          closable
          onClose={() => setOpen(false)}
          open={open}
        >
          <Menu mode="vertical" className="menuBar">
            {menuItems.map(({ key, label, section, path }) => (
              <Menu.Item
                key={key}
                onClick={() => {
                  if (section) {
                    scrollToSection(section);
                  } else if (path) {
                    history.push(path);
                  }
                }}
                style={{ width: "100%", display: "flex", alignItems: "center" }}
              >
                {typeof label === "string" ? (
                  <Typography className="navbarText">{label}</Typography>
                ) : (
                  label
                )}
              </Menu.Item>
            ))}
          </Menu>
        </Drawer>
      </Col>
    </Row>
  );
};
export default HomeHeader;
